import { cloneDeep, isEqual } from "lodash";
import { createPatch, Patch } from "rfc6902";
import { isEditableMetadataPath } from "./isEditableMetadataPath";
import { omitEditableMetadata } from "./omitEditableMetadata";
import { toEditableData } from "./toEditableData";

/**
 * Builds isolated reversible operations while retaining complete added and removed entity values.
 *
 * @param before - Complete selected domain objects before the action.
 * @param after - Complete selected domain objects after the action.
 * @returns Full-value patches excluding operations targeting ignored metadata fields.
 */
export const editablePatch = (
  before: ReturnType<typeof toEditableData>,
  after: ReturnType<typeof toEditableData>,
): Patch => {
  // Omission is only a no-op check; operation values always come from complete domain objects.
  if (isEqual(omitEditableMetadata(before), omitEditableMetadata(after))) return [];
  return cloneDeep(
    createPatch(before, after).filter(
      (operation) =>
        !isEditableMetadataPath(
          operation.path
            .split("/")
            .slice(1)
            .map((segment) => segment.replace(/~1/g, "/").replace(/~0/g, "~")),
        ),
    ),
  );
};
